import React from 'react';
import { Star } from 'lucide-react';
import { classNames } from '@/lib/format';

/** Render a 1–5 star row from a numeric score (supports half-stars). */
export function StarRating({ score, max = 5, className, testId }) {
  if (score == null || Number.isNaN(Number(score))) return null;
  const clamped = Math.max(0, Math.min(max, Number(score)));
  const stars = [];
  for (let i = 1; i <= max; i += 1) {
    const fill = clamped >= i ? 1 : clamped >= i - 0.5 ? 0.5 : 0;
    stars.push(
      <span key={i} className="relative inline-block h-3.5 w-3.5">
        <Star className="absolute inset-0 h-3.5 w-3.5 text-muted-foreground/30" />
        {fill > 0 && (
          <span className="absolute inset-0 overflow-hidden" style={{ width: `${fill * 100}%` }}>
            <Star className="h-3.5 w-3.5 fill-amber-400 text-amber-400" />
          </span>
        )}
      </span>,
    );
  }
  return (
    <div className={classNames('flex items-center gap-1', className)} data-testid={testId}>
      <span className="flex items-center gap-0.5">{stars}</span>
      <span className="text-[11px] font-medium tabular-nums text-muted-foreground">{clamped.toFixed(1)}</span>
    </div>
  );
}
